document.addEventListener('DOMContentLoaded', function() {
  cSearchCategoryChangeTrigger();
  cTabChangeTrigger();
  cChangeTrigger();
  cSearchCustomCheckboxTrigger();
  cSmoothScrollTrigger();
  cMobileSlideTrigger();
  cProductSlideTrigger();
  cSlideMvTorigger();
  cProducSlideCenterTrigger();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      cSearchCategoryChangeTrigger();
      cTabChangeTrigger();
      cChangeTrigger();
      cSearchCustomCheckboxTrigger();
      cSmoothScrollTrigger();
      cMobileSlideTrigger();
      cProductSlideTrigger();
      cSlideMvTorigger();
      cProducSlideCenterTrigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      cSearchCategoryChangeTrigger();
      cTabChangeTrigger();
      cChangeTrigger();
      cSearchCustomCheckboxTrigger();
      cSmoothScrollTrigger();
      cMobileSlideTrigger();
      cProductSlideTrigger();
      cSlideMvTorigger();
      cProducSlideCenterTrigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', (e) => {
      cSearchCategoryChangeTrigger();
      cTabChangeTrigger();
      cChangeTrigger();
      cSearchCustomCheckboxTrigger();
      cSmoothScrollTrigger();
      cMobileSlideTrigger();
      cProductSlideTrigger();
      cSlideMvTorigger();
      cProducSlideCenterTrigger();
    });
}


/****************************************
     遅延関数のJS
****************************************/
function customDebounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}


/****************************************
    タブ切り替えセクションのJS
****************************************/
function cTabChangeTrigger() {
    if (document.querySelectorAll('.c-tab__section').length) {
        cTabChange();
    }
};

function cTabChange() {
    const sections = document.querySelectorAll('.c-tab__section');
    
    sections.forEach((section) => {
        const tabList = section.querySelectorAll('.c-tab__list');
        const tabContent = section.querySelectorAll('.c-tab__content');

        function activateTab(tab) {
            section.querySelector('.is-active').classList.remove('is-active');
            tab.classList.add('is-active');
            section.querySelector('.is-show').classList.remove('is-show');
            const aryTabs = Array.prototype.slice.call(tabList);
            const index = aryTabs.indexOf(tab);
            tabContent[index].classList.add('is-show');
        }

        tabList.forEach((tab, i) => {
            tab.addEventListener('click', () => {
                activateTab(tab);
            });
        });
    });
}


/****************************************
    タブによるリンクの切り替えJS
****************************************/
function cChangeTrigger() {
    if (document.querySelectorAll('.c-linkchange__section').length) {
        cLinkChange();
    }
};

function cLinkChange() {
    const sections = document.querySelectorAll('.c-linkchange__section');
  
    sections.forEach((section) => {
        const tabList = section.querySelectorAll('.c-tab__list');
        const tabContent = section.querySelectorAll('.c-tab__content');
        const moreBtn = section.querySelector('.c-morebtn__box.lg-max-hidden .c-morebtn__link');

        tabList.forEach((tab, i) => {
            tab.addEventListener('click', () => {
                const collectionLink = tab.getAttribute('data-collection-link');
                moreBtn?.setAttribute('href', collectionLink);
            });
        });
    });
}


/****************************************
    検索リンクのJS
****************************************/  
function cSearchCategoryChangeTrigger() {
    if (document.querySelectorAll('.c-header__searchwrap').length) {
        cSearchCategoryChange();
    }
};

function cSearchCategoryChange() {
    const searchWrap = document.querySelector('.c-header__searchwrap');
    const searchCategory = searchWrap.querySelector('.c-select-category select');
    const searchForm = searchWrap.querySelector('#js-header__searchform');
    const searchInput = searchWrap.querySelector('.c-header__search');
  
    searchForm?.addEventListener('submit', function(event) {
        event.preventDefault();

        let searchUrl;
        const selectedCategory = searchCategory.value;
        const searchText = searchInput.value;

        if (selectedCategory !== 'all') {
            searchUrl = '/search?q=' + encodeURIComponent(selectedCategory + ' ' + searchText);
        } else {
            searchUrl = '/search?q=' + encodeURIComponent(searchText);
        }

        window.location.href = searchUrl;

        const checkbox = document.querySelector('.c-psa10__checkbox');
        if (checkbox) sessionStorage.setItem('roseTorecaCheckboxChecked', 'false');
    });
}


/****************************************
    メインビジュアルのスライダーJS
****************************************/
function cSlideMvTorigger() {
    if (document.querySelectorAll('.c-mv__section').length) {
        cSlideMv();
    }
};

function cSlideMv() {
    $('.c-mv__section').each(function() {
        const $section = $(this);
        const $slickMain = $(this).find('.slider-main.slider');
        const $slickNav = $(this).find('.slider-nav.slider');

        const blockSize = $section.data('blockSize');
        let slideNum = blockSize;
        let centerModeCheckMain = true;
        let centerModeCheckNav = true;

        const mediaQuery999 = window.matchMedia('(max-width: 999px)');
        const mediaQuery699 = window.matchMedia('(max-width: 699px)');

        function handleMediaQueryChange() {
            let maxSlideMainNum = 1
            let maxSlideNavNum;
          
            if (mediaQuery699.matches) {
                maxSlideNavNum = 3;
            } else if (mediaQuery999.matches) {
                maxSlideNavNum = 5;
            } else {
                maxSlideNavNum = 7;
            }
        
            if (mediaQuery699.matches && blockSize >= maxSlideNavNum) {
                slideNum = 3;
            } else if (mediaQuery999.matches && blockSize >= maxSlideNavNum) {
                slideNum = 5;
            } else if (!mediaQuery699.matches && !mediaQuery999.matches && blockSize >= maxSlideNavNum) {
                slideNum = 7;
            }

            if (blockSize <= maxSlideMainNum) {
                centerModeCheckMain = false;
            } else {
                centerModeCheckMain = true;
            }
          
            if (blockSize <= maxSlideNavNum) {
                $section.addClass('c-few-img');
                centerModeCheckNav = false;
            } else {
                $section.removeClass('c-few-img');
                centerModeCheckNav = true;
            }

            if ($slickNav.hasClass('slick-initialized')) {
                $slickNav.slick('slickSetOption', 'slidesToShow', slideNum, true);
                $slickNav.slick('slickSetOption', 'centerMode', centerModeCheckNav, true);
              
                $slickMain.slick('slickSetOption', 'centerMode', centerModeCheckMain, true);
            }
        }

        $slickMain.on('init', function() {
            $section.addClass('is-visible');
        });

        handleMediaQueryChange();
        const debouncedHandleMediaQueryChange = customDebounce(handleMediaQueryChange, 200);
        mediaQuery999.addListener(debouncedHandleMediaQueryChange);
        mediaQuery699.addListener(debouncedHandleMediaQueryChange);

        $slickMain.not('.slick-initialized').slick({
            autoplay: true,
            arrows: true,
            centerMode: centerModeCheckMain,
            centerPadding: "22%",
            speed: 1000,
            pauseOnFocus: false,
            pauseOnHover: false,
            asNavFor: '.slider-nav',
            prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse lg-max-hidden"><span class="c-arrow__svg"></span></button>',
            nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal lg-max-hidden"><span class="c-arrow__svg"></span></button>',
            responsive: [
                {
                    breakpoint: 700,
                    settings: {
                        arrows: false,
                        centerPadding: "4.5%",
                    },
                },
            ],
        });
        
        $slickNav.not('.slick-initialized').slick({
            slidesToShow: slideNum,
            slidesToScroll: 1,
            centerMode: centerModeCheckNav,
            centerPadding: "2.5%",
            asNavFor: '.slider-main',
            arrows: false,
            dots: false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: slideNum,
                        centerPadding: "4%",
                    },
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: slideNum,
                        centerPadding: "15%",
                    },
                },
            ],
        });
    });
}


/****************************************
    商品一覧のサイドスライダーJS
****************************************/
function cProductSlideTrigger() {
    if (document.querySelectorAll('.c-rside-slide__section').length) {
        cProductSlide();
    }
};

function cProductSlide() {
    const sectionList = document.querySelectorAll('.c-rside-slide__section');
  
    $('.c-rside-slide__section').each(function() {
        const $section = $(this);
        const $slickEls = $(this).find('.c-productlist__box.slider');

        $slickEls.each(function() {
            const $slick = $(this);

            const productNum = $slick.data('productNum');
            const slideNum = $slick.data('slideNum');
        
            const mediaQuery1399 = window.matchMedia('(max-width: 1399px)');
            const mediaQuery1199 = window.matchMedia('(max-width: 1199px)');
            const mediaQuery999 = window.matchMedia('(max-width: 999px)');
            const mediaQuery389 = window.matchMedia('(max-width: 389px)');

            let maxProductNum;
            function handleMediaQueryChange() {
                if (mediaQuery389.matches) {
                    maxProductNum = 1;
                } else if (mediaQuery999.matches) {
                    maxProductNum = 2;
                } else if (mediaQuery1199.matches) {
                    maxProductNum = 3;
                } else if (mediaQuery1399.matches) {
                    maxProductNum = 4;
                } else {
                    maxProductNum = 5;
                }

                if (productNum <= maxProductNum || slideNum <= maxProductNum) {
                    $slick.addClass('c-stack-slick');
                    if ($slick.hasClass('slick-initialized')) {
                        $slick.slick('unslick');
                    }
                } else {
                    $slick.removeClass('c-stack-slick');
                    if ($slick.hasClass('slick-initialized')) {
                        initializeSlick($slick);
                    }
                }
            }

            handleMediaQueryChange();
            const debouncedHandleMediaQueryChange = customDebounce(handleMediaQueryChange, 200);
            mediaQuery1399.addListener(debouncedHandleMediaQueryChange);
            mediaQuery1199.addListener(debouncedHandleMediaQueryChange);
            mediaQuery999.addListener(debouncedHandleMediaQueryChange);
            mediaQuery389.addListener(debouncedHandleMediaQueryChange);

            function initializeSlick($slick) {
                $slick.not('.slick-initialized').slick({
                    autoplay: false,
                    speed: 600,
                    arrows: true,
                    dots: false,
                    slidesToShow: 5.4,
                    slidesToScroll: 4,
                    infinite: false,
                    prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse md-max-hidden"><span class="c-arrow__svg"></span></button>',
                    nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal md-max-hidden"><span class="c-arrow__svg"></span></button>',
                    responsive: [
                        {
                            breakpoint: 1400,
                            settings: {
                                slidesToShow: 4.4,
                                slidesToScroll: 4,
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3.4,
                                slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 2.1,
                                slidesToScroll: 2,
                                arrows: false,
                            }
                        },
                        {
                            breakpoint: 390,
                            settings: {
                                slidesToShow: 1.1,
                                slidesToScroll: 1,
                                arrows: false,
                            }
                        }
                    ]
                });
            }

            function productNumCheck() {
              if (!(productNum <= maxProductNum || slideNum <= maxProductNum)) {
                  initializeSlick($slick);
              }
            }
            productNumCheck();

            const debouncedProductNumCheck = customDebounce(productNumCheck, 200);
            window.addEventListener('resize', debouncedProductNumCheck);
        });
    });
};
window.cProductSlideTrigger = cProductSlideTrigger;


/****************************************
    商品一覧のセンタースライダーJS
****************************************/
function cProducSlideCenterTrigger() {
    if (document.querySelectorAll('.c-center-slide__section').length) {
        cProducSlideCenter();
    }
};

function cProducSlideCenter() {
    $('.c-center-slide__section').each(function() {
        const $section = $(this);
        const $slickEls = $(this).find('.c-ranking__box.slider');

        $slickEls.each(function() {
            const $slick = $(this);

            const productNum = $slick.data('productNum');
            const slideNum = $slick.data('slideNum');
            let centerModeCheck = true;
        
            const mediaQuery1399 = window.matchMedia('(max-width: 1399px)');
            const mediaQuery1199 = window.matchMedia('(max-width: 1199px)');
            const mediaQuery999 = window.matchMedia('(max-width: 999px)');
            const mediaQuery389 = window.matchMedia('(max-width: 389px)');

            let maxProductNum;
            function handleMediaQueryChange() {
                 if (mediaQuery389.matches) {
                    maxProductNum = 1;
                } else if (mediaQuery999.matches) {
                    maxProductNum = 2;
                } else if (mediaQuery1199.matches) {
                    maxProductNum = 3;
                } else if (mediaQuery1399.matches) {
                    maxProductNum = 4;
                } else {
                    maxProductNum = 5;
                }

                if (productNum <= maxProductNum || slideNum <= maxProductNum) {
                    $slick.addClass('c-stack-slick');
                    if ($slick.hasClass('slick-initialized')) {
                        $slick.slick('unslick');
                        centerModeCheck = false;
                    }
                } else {
                    $slick.removeClass('c-stack-slick');
                    if ($slick.hasClass('slick-initialized')) {
                        initializeSlick($slick);
                        centerModeCheck = true;
                    }
                }

                if ($slick.hasClass('slick-initialized')) {
                    $slick.slick('slickSetOption', 'centerMode', centerModeCheck, true);
                }
            }

            $slick.on('init', function(event, slick) {
                cRankDecoCssTrigger();
                hideQuickBuyModalInClones($slick);
            });
            $slick.on('afterChange', function(event, slick, currentSlide) {
                cRankDecoCssTrigger();
                hideQuickBuyModalInClones($slick);
            });

            handleMediaQueryChange();
            const debouncedHandleMediaQueryChange = customDebounce(handleMediaQueryChange, 200);
            mediaQuery1399.addListener(debouncedHandleMediaQueryChange);
            mediaQuery1199.addListener(debouncedHandleMediaQueryChange);
            mediaQuery999.addListener(debouncedHandleMediaQueryChange);
            mediaQuery389.addListener(debouncedHandleMediaQueryChange);

            function initializeSlick($slick) {
                $slick.not('.slick-initialized').slick({
                    autoplay: false,
                    speed: 600,
                    arrows: true,
                    dots: false,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    centerPadding: '0',
                    centerMode: centerModeCheck,
                    prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse md-max-hidden"><span class="c-arrow__svg"></span></button>',
                    nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal md-max-hidden"><span class="c-arrow__svg"></span></button>',
                    responsive: [
                        {
                            breakpoint: 1400,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                centerPadding: '0',
                                arrows: false,
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerPadding: '26.5%',
                                arrows: false,
                            }
                        }
                    ]
                });
            }

            function productNumCheck() {
              if (!(productNum <= maxProductNum || slideNum <= maxProductNum)) {
                  initializeSlick($slick);
              }
            }
            productNumCheck();

            function hideQuickBuyModalInClones($slick) {
                const clones = $slick.find('.slick-cloned .quick-buy-modal');
                clones.each(function() {
                    this.remove();
                });
            }

            const debouncedProductNumCheck = customDebounce(productNumCheck, 200);
            window.addEventListener('resize', debouncedProductNumCheck);
        });
    });
};


/****************************************
    ランキング装飾のCSS付与のJS
****************************************/
function cRankDecoCssTrigger() {
    if (document.querySelectorAll('.c-ranking__section[data-rank-deco="true"]').length) {
        cRankDecoCss();
    }
};

function cRankDecoCss() {
    const sectionList = document.querySelectorAll('.c-ranking__section[data-rank-deco="true"]');

    sectionList.forEach((section) => {
        const contentList = section.querySelectorAll('.c-tab__content');

        contentList.forEach((content) => {
            const rankingBox = content.querySelector('.c-ranking__box');
            const itemList = content.querySelectorAll('.c-product-card__box');

            const productNum = parseInt(rankingBox.getAttribute('data-product-num'), 10);

            itemList.forEach(item => {
                const index = parseInt(item.getAttribute('data-slick-index'), 10);
                const rankingNum = item.querySelector('.c-ranking__num');
              
                if (index === productNum) {
                    rankingNum.classList.add('c-numberone-color');
                } else if (index === productNum + 1) {
                    rankingNum.classList.add('c-numbertwo-color');
                } else if (index === productNum + 2) {
                    rankingNum.classList.add('c-numberthree-color');
                } else if (index >= 3 || (index <= -1 && index >= -3)) {
                    rankingNum.classList.add('c-common-color');
                }
            });
        });
    });
}


/****************************************
    モバイルスライダーのJS
****************************************/
function cMobileSlideTrigger() {
    if (document.querySelectorAll('.c-mobile-slide__section').length) {
        cMobileSlide();
    }
};

function cMobileSlide() {
    $('.c-mobile-slide__section').each(function() {
        const $section = $(this);
        const $slickEls = $(this).find('.c-info__inner.slider');

        const mobileSlide = $(this).data('mobileSlide');

        $slickEls.each(function() {
            const $slick = $(this);

            const infoNum = $slick.data('infoNum');
            const slideNum = $slick.data('slideNum');
        
            const mediaQuery699 = window.matchMedia('(max-width: 699px)');

            let maxInfoNum;
            function handleMediaQueryChange() {
                 if (mediaQuery699.matches) {
                    maxInfoNum = 1;
                }

                if (infoNum <= maxInfoNum || slideNum <= maxInfoNum) {
                    $slick.addClass('c-stack-slick');
                    if ($slick.hasClass('slick-initialized')) {
                        $slick.slick('unslick');
                    }
                } else {
                    $slick.removeClass('c-stack-slick');
                    if ($slick.hasClass('slick-initialized')) {
                        initializeSlick($slick);
                    }
                }
            }

            function checkBreakPoint() {
                const width = $(window).width();
                if (mobileSlide === false) {
                    if ($slick.hasClass('slick-initialized')) {
                        $slick.slick('unslick');
                    }
                } else {
                    if (width <= 700) {
                        initializeSlick($slick);
                    } else {
                        if ($slick.hasClass('slick-initialized')) {
                            $slick.slick('unslick');
                        }
                    }
                }
            }

            function initializeSlick($slick) {
                $slick.not('.slick-initialized').slick({
                    autoplay: false,
                    speed: 600,
                    arrows: false,
                    dots: false,
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    infinite: false,
                });
            }

            handleMediaQueryChange();
            const debouncedHandleMediaQueryChange = customDebounce(handleMediaQueryChange, 200);
            mediaQuery699.addListener(debouncedHandleMediaQueryChange);

            checkBreakPoint();
            const debouncedCheckBreakPoint = customDebounce(checkBreakPoint, 200);
            window.addEventListener('resize', debouncedCheckBreakPoint);
        });
    });
};


/****************************************
    検索ページのカスタムチェックボックスのJS
****************************************/
function cSearchCustomCheckboxTrigger() {
    const checkbox = document.querySelector('.c-psa10__checkbox');

    function strageCheck() {
      if (sessionStorage.getItem('roseTorecaCheckboxChecked') === 'true') {
          sessionStorage.setItem('roseTorecaCheckboxChecked', 'false');
      }
    }

    const nonSearchFormList = document.querySelectorAll('.main-search-form');
    nonSearchFormList.forEach((nonSearchForm) => {
      nonSearchForm?.addEventListener('submit', function() {
        strageCheck();
      });
    });
  
    if (checkbox) {
      cSearchCustomCheckbox();
      
      const mobileSearchForm = document.querySelector('#predictive-search-form');
      mobileSearchForm?.addEventListener('submit', function(event) {
        strageCheck();
      });
    } else {
        strageCheck();
    }
}


function cSearchCustomCheckbox() {
    const tagName = 'PSA10';
    const currentUrl = new URL(window.location.href);
    if (!currentUrl.pathname.includes('/search')) {
      sessionStorage.setItem('roseTorecaCheckboxChecked', 'false');
    }
}


/****************************************
     トップへ戻るボタン
****************************************/
function cSmoothScrollTrigger() {
    if (document.querySelectorAll('.c-smoothscroll').length) {
        cSmoothScroll();
    }
};

function cSmoothScroll() {
    let viewOffset = 160;
    const smoothScrollEl = document.querySelector('.c-smoothscroll');

    function viewSmoothScroll() {
        if (window.pageYOffset > viewOffset) {
            smoothScrollEl.classList.add('c-view');
        } else {
            smoothScrollEl.classList.remove('c-view');
        }
    }

    function handleResize() {
        if (window.innerWidth <= 700 && smoothScrollEl.classList.contains('c-hidden')) {
            smoothScrollEl.classList.remove('c-view');
            window.removeEventListener('scroll', viewSmoothScroll);
        } else {
            viewSmoothScroll();
            window.addEventListener('scroll', viewSmoothScroll);
        }
    }

    smoothScrollEl.addEventListener('click', function() {
        window.scroll({ top: 0, behavior: "smooth" });
    });

    const debouncedHandleResize = customDebounce(handleResize, 200);
    window.addEventListener("resize", debouncedHandleResize, false);
    handleResize();
}